import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function InvestmentDetail() {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('overview');

  const investments = [
    {
      id: "blue-ridge",
      numericId: 4,
      title: 'Blue Ridge Mountain Retreat',
      location: 'North Georgia Mountains',
      type: 'development',
      targetReturn: '22%',
      minInvestment: 125000,
      totalRaise: 2000000,
      currentRaised: 1500000,
      timeline: '3 years',
      status: 'active',
      image: 'https://public.readdy.ai/ai/img_res/2369c87208684d852759a6178669622b.jpg',
      highlights: ['Mountain Views', 'Hiking Trails', 'Luxury Amenities', 'Proven Management Team'],
      description: 'Premium mountain glamping experience with stunning Blue Ridge views and world-class amenities.',
      fullDescription: 'The Blue Ridge Mountain Retreat offers investors the opportunity to develop a premier glamping destination in the historic Blue Ridge Mountains of North Carolina. This 100-acre property features stunning Appalachian views, hiking trails, and proximity to the Blue Ridge Parkway. The development will include 10 luxury mountain accommodations, each designed to showcase the natural beauty of the region. Guests will enjoy hiking, mountain biking, fishing, and seasonal activities like fall foliage tours and winter cozy retreats.',
      financials: {
        totalProjectCost: 2300000,
        landAcquisition: 500000,
        development: 1300000,
        infrastructure: 300000,
        contingency: 200000,
        projectedRevenue: {
          year1: 800000,
          year2: 1200000,
          year3: 1600000
        },
        occupancyRate: '75%',
        averageDailyRate: 300
      },
      timelinePhases: [
        { phase: 'Mountain Land Acquisition', duration: '2 months', status: 'completed' },
        { phase: 'Trail & Access Development', duration: '4 months', status: 'in-progress' },
        { phase: 'Mountain Infrastructure', duration: '5 months', status: 'upcoming' },
        { phase: 'Luxury Unit Construction', duration: '10 months', status: 'upcoming' },
        { phase: 'Activity Center Development', duration: '4 months', status: 'upcoming' },
        { phase: 'Soft Opening', duration: '1 month', status: 'upcoming' }
      ],
      team: [
        { name: 'Sarah Blue Ridge', role: 'Mountain Development Director', experience: '16 years Appalachian construction' },
        { name: 'Ridge Thomas', role: 'Adventure Activities Manager', experience: '12 years mountain recreation' },
        { name: 'Carolina Smith', role: 'Southern Hospitality Director', experience: '14 years regional tourism' }
      ],
      risks: [
        'Mountain weather construction delays',
        'Seasonal access limitations',
        'Environmental mountain regulations',
        'Regional tourism market changes'
      ],
      documents: [
        'Blue Ridge Development Plan',
        'Mountain Construction Strategy',
        'Adventure Activities Program',
        'Regional Tourism Analysis',
        'Environmental Mountain Study'
      ]
    },
    {
      id: "redwood-forest",
      numericId: 2,
      title: 'Redwood Forest Sanctuary',
      location: 'Northern California',
      type: 'development',
      targetReturn: '18%',
      minInvestment: 150000,
      totalRaise: 1500000,
      currentRaised: 675000,
      timeline: '4 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20redwood%20forest%20glamping%20investment%20property%20with%20elevated%20tiny%20homes%20among%20giant%20trees%2C%20professional%20real%20estate%20photography%2C%20dappled%20forest%20lighting%2C%20eco-friendly%20accommodations%2C%20investment%20development%20showcase&width=800&height=500&seq=redwood-invest-detail&orientation=landscape',
      highlights: ['Ancient Redwood Setting', '8 Elevated Units', 'Eco-Luxury Design', 'Forest Conservation'],
      description: 'Eco-luxury forest retreat featuring 8 elevated glamping units among ancient redwoods.',
      fullDescription: 'The Redwood Forest Sanctuary offers a unique opportunity to create an eco-luxury retreat among some of California\'s most majestic ancient redwoods. This 80-acre property features pristine old-growth forest with hiking trails and wildlife viewing opportunities. The development will include 8 elevated glamping units designed to minimize environmental impact while maximizing comfort and connection with nature. Each unit will feature sustainable materials, solar power, and panoramic forest views.',
      financials: {
        totalProjectCost: 1900000,
        landAcquisition: 400000,
        development: 1100000,
        infrastructure: 250000,
        contingency: 150000,
        projectedRevenue: {
          year1: 600000,
          year2: 900000,
          year3: 1200000
        },
        occupancyRate: '72%',
        averageDailyRate: 325
      },
      timelinePhases: [
        { phase: 'Environmental Studies', duration: '4 months', status: 'completed' },
        { phase: 'Design & Permits', duration: '6 months', status: 'in-progress' },
        { phase: 'Site Access Development', duration: '4 months', status: 'upcoming' },
        { phase: 'Elevated Platform Construction', duration: '8 months', status: 'upcoming' },
        { phase: 'Unit Installation', duration: '6 months', status: 'upcoming' },
        { phase: 'Grand Opening', duration: '2 months', status: 'upcoming' }
      ],
      team: [
        { name: 'Michael Green', role: 'Eco-Development Director', experience: '18 years sustainable construction' },
        { name: 'Rachel Forest', role: 'Environmental Consultant', experience: '14 years forest conservation' },
        { name: 'James Redwood', role: 'Construction Supervisor', experience: '16 years elevated construction' }
      ],
      risks: [
        'Environmental permit complexity',
        'Weather-related construction delays',
        'Protected species considerations',
        'Access road challenges'
      ],
      documents: [
        'Environmental Impact Assessment',
        'Forest Conservation Plan',
        'Elevated Construction Designs',
        'Sustainability Certifications',
        'Financial Projections'
      ]
    },
    {
      id: "desert-oasis",
      numericId: 3,
      title: 'Desert Oasis Retreat',
      location: 'Arizona Sonoran Desert',
      type: 'expansion',
      targetReturn: '25%',
      minInvestment: 110000,
      totalRaise: 3000000,
      currentRaised: 900000,
      timeline: '5 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20desert%20glamping%20resort%20investment%20property%20with%20modern%20tiny%20homes%20in%20southwestern%20landscape%2C%20professional%20real%20estate%20photography%2C%20dramatic%20sunset%20lighting%2C%20contemporary%20accommodations%2C%20high-end%20investment%20opportunity&width=800&height=500&seq=desert-invest-detail&orientation=landscape',
      highlights: ['Desert Views', 'Stargazing', 'Unique Landscape', 'Year-Round Operations'],
      description: 'Unique desert glamping with spectacular stargazing and iconic Sonoran landscape.',
      fullDescription: 'The Desert Oasis Resort expansion builds upon our successful existing desert property by adding 15 premium luxury accommodations and a world-class spa facility. Located in the pristine Sonoran Desert, this property offers stunning mountain views, unique desert wildlife viewing, and access to hiking trails. The expansion includes luxury desert suites, a full-service spa, wellness center, and guided desert experiences. The desert location provides year-round appeal with mild winters and spectacular stargazing opportunities.',
      financials: {
        totalProjectCost: 3800000,
        landAcquisition: 0,
        development: 2800000,
        infrastructure: 600000,
        contingency: 400000,
        projectedRevenue: {
          year1: 1800000,
          year2: 2500000,
          year3: 3200000
        },
        occupancyRate: '80%',
        averageDailyRate: 450
      },
      timelinePhases: [
        { phase: 'Expansion Planning', duration: '3 months', status: 'completed' },
        { phase: 'Desert Permits & Studies', duration: '4 months', status: 'completed' },
        { phase: 'Site Preparation', duration: '6 months', status: 'in-progress' },
        { phase: 'Luxury Suite Construction', duration: '12 months', status: 'upcoming' },
        { phase: 'Spa Facility Development', duration: '8 months', status: 'upcoming' },
        { phase: 'Grand Opening', duration: '2 months', status: 'upcoming' }
      ],
      team: [
        { name: 'Carlos Mesa', role: 'Desert Development Director', experience: '20 years desert construction' },
        { name: 'Isabella Sage', role: 'Spa & Wellness Director', experience: '15 years luxury wellness' },
        { name: 'Roberto Cactus', role: 'Desert Operations Manager', experience: '12 years desert hospitality' }
      ],
      risks: [
        'Extreme weather construction challenges',
        'Water usage regulations',
        'Desert wildlife protection requirements',
        'Seasonal tourism fluctuations'
      ],
      documents: [
        'Desert Expansion Plan',
        'Spa Development Strategy',
        'Water Usage Compliance',
        'Wildlife Impact Study',
        'Luxury Market Analysis'
      ]
    },
    {
      id: "lowcountry-lodge",
      numericId: 8,
      title: 'Lowcountry Lodge',
      location: 'South Carolina Coast',
      type: 'development',
      targetReturn: '20%',
      minInvestment: 135000,
      totalRaise: 1600000,
      currentRaised: 480000,
      timeline: '3 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20South%20Carolina%20Lowcountry%20glamping%20investment%20property%20with%20elegant%20tiny%20homes%20among%20Spanish%20moss%20draped%20oak%20trees%2C%20professional%20real%20estate%20photography%2C%20southern%20charm%20setting%2C%20historic%20plantation%20style%20accommodations%2C%20Charleston%20area%20investment&width=800&height=500&seq=lowcountry-lodge-detail&orientation=landscape',
      highlights: ['Coastal Access', 'Southern Charm', 'Wildlife Viewing', 'Cultural Access'],
      description: 'Southern coastal glamping with access to pristine beaches and rich wildlife.',
      fullDescription: 'The South Carolina Lowcountry Lodge celebrates the rich heritage and natural beauty of the Charleston region with 9 luxury accommodations inspired by historic plantation architecture. This 90-acre property features Spanish moss-draped oak trees, tidal marshes, and wildlife viewing opportunities. The development preserves the historic character while providing modern luxury amenities. Guests will enjoy marsh views, cultural experiences, Charleston access, and traditional Lowcountry hospitality. The location provides year-round appeal with mild seasons and rich cultural attractions.',
      financials: {
        totalProjectCost: 2000000,
        landAcquisition: 450000,
        development: 1200000,
        infrastructure: 250000,
        contingency: 100000,
        projectedRevenue: {
          year1: 700000,
          year2: 1000000,
          year3: 1300000
        },
        occupancyRate: '74%',
        averageDailyRate: 285
      },
      timelinePhases: [
        { phase: 'Historic Site Assessment', duration: '2 months', status: 'completed' },
        { phase: 'Heritage Preservation Planning', duration: '3 months', status: 'in-progress' },
        { phase: 'Lowcountry Infrastructure', duration: '4 months', status: 'upcoming' },
        { phase: 'Heritage Unit Construction', duration: '8 months', status: 'upcoming' },
        { phase: 'Cultural Center Development', duration: '4 months', status: 'upcoming' },
        { phase: 'Historic Lodge Opening', duration: '2 months', status: 'upcoming' }
      ],
      team: [
        { name: 'Charleston Heritage', role: 'Historic Development Director', experience: '20 years Lowcountry preservation' },
        { name: 'Lowcountry Marsh', role: 'Cultural Programs Manager', experience: '15 years regional heritage' },
        { name: 'Spanish Moss', role: 'Southern Hospitality Director', experience: '12 years Charleston tourism' }
      ],
      risks: [
        'Historic preservation requirements',
        'Marsh environmental regulations',
        'Seasonal tourism patterns',
        'Cultural sensitivity considerations'
      ],
      documents: [
        'Historic Preservation Plan',
        'Lowcountry Cultural Program',
        'Marsh Environmental Study',
        'Charleston Regional Analysis',
        'Heritage Tourism Strategy'
      ]
    },
    {
      id: "tennessee-valley",
      numericId: 6,
      title: 'Tennessee Valley Vista',
      location: 'East Tennessee',
      type: 'expansion',
      targetReturn: '19%',
      minInvestment: 120000,
      totalRaise: 2200000,
      currentRaised: 880000,
      timeline: '4 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Tennessee%20valley%20glamping%20investment%20property%20with%20modern%20tiny%20homes%20overlooking%20rolling%20hills%20and%20rivers%2C%20professional%20real%20estate%20photography%2C%20golden%20hour%20lighting%2C%20contemporary%20mountain%20accommodations%2C%20Smoky%20Mountains%20backdrop&width=800&height=500&seq=tennessee-valley-detail&orientation=landscape',
      highlights: ['Valley Views', 'Music Heritage', 'Outdoor Adventures', 'River Access'],
      description: 'Appalachian glamping with rich music heritage and stunning valley vistas.',
      fullDescription: 'The Tennessee Valley Escape expansion creates a modern glamping destination in the scenic Tennessee Valley with stunning views of rolling hills and river access. This 150-acre property features diverse landscapes from valley meadows to wooded hillsides, with a flowing river perfect for fishing and kayaking. The development will include 14 modern luxury accommodations, a music venue celebrating Tennessee\'s heritage, and extensive outdoor recreation facilities. The location provides easy access to Great Smoky Mountains National Park and Tennessee\'s famous music destinations.',
      financials: {
        totalProjectCost: 2800000,
        landAcquisition: 600000,
        development: 1600000,
        infrastructure: 400000,
        contingency: 200000,
        projectedRevenue: {
          year1: 1100000,
          year2: 1600000,
          year3: 2100000
        },
        occupancyRate: '76%',
        averageDailyRate: 320
      },
      timelinePhases: [
        { phase: 'Valley Land Development', duration: '3 months', status: 'completed' },
        { phase: 'River Access Construction', duration: '4 months', status: 'completed' },
        { phase: 'Valley Infrastructure', duration: '6 months', status: 'in-progress' },
        { phase: 'Modern Unit Construction', duration: '10 months', status: 'upcoming' },
        { phase: 'Music Venue Construction', duration: '6 months', status: 'upcoming' },
        { phase: 'Grand Valley Opening', duration: '2 months', status: 'upcoming' }
      ],
      team: [
        { name: 'Valley Tennessee', role: 'Valley Development Director', experience: '19 years Tennessee development' },
        { name: 'River Music', role: 'Entertainment & Activities', experience: '15 years Tennessee music industry' },
        { name: 'Smoky Mountain', role: 'Outdoor Recreation Manager', experience: '13 years adventure tourism' }
      ],
      risks: [
        'River seasonal flooding',
        'Music venue licensing',
        'Smoky Mountain access regulations',
        'Valley weather construction delays'
      ],
      documents: [
        'Tennessee Valley Master Plan',
        'River Access Development',
        'Music Heritage Program',
        'Outdoor Recreation Strategy',
        'Smoky Mountain Proximity Benefits'
      ]
    },
    {
      id: "alpine-meadows",
      numericId: 1,
      title: 'Alpine Meadows Resort',
      location: 'Colorado Rockies',
      type: 'development',
      targetReturn: '24%',
      minInvestment: 160000,
      totalRaise: 2000000,
      currentRaised: 1500000,
      timeline: '3 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20alpine%20glamping%20retreat%20investment%20property%20with%20multiple%20tiny%20homes%20in%20mountain%20meadow%2C%20professional%20real%20estate%20photography%2C%20snow-capped%20peaks%20background%2C%20modern%20outdoor%20accommodations%2C%20investment%20opportunity%20showcase&width=800&height=500&seq=alpine-invest-detail&orientation=landscape',
      highlights: ['Alpine Setting', 'Ski Access', 'Mountain Adventures', 'World-Class Amenities'],
      description: 'High-altitude glamping with year-round outdoor activities and breathtaking alpine scenery.',
      fullDescription: 'The Alpine Meadows Retreat represents a unique opportunity to develop a world-class glamping destination in one of the Colorado Rockies\' most pristine locations. This 120-acre property features old-growth forest, mountain views, and proximity to popular outdoor recreation areas. The development will include 12 luxury accommodations ranging from safari tents to treehouses, a central lodge with dining and event facilities, spa services, and guided adventure activities. Our experienced development team has successfully completed similar projects with average returns exceeding 20%.',
      financials: {
        totalProjectCost: 2600000,
        landAcquisition: 600000,
        development: 1500000,
        infrastructure: 350000,
        contingency: 150000,
        projectedRevenue: {
          year1: 1000000,
          year2: 1500000,
          year3: 2000000
        },
        occupancyRate: '78%',
        averageDailyRate: 375
      },
      timelinePhases: [
        { phase: 'Land Acquisition & Permits', duration: '3 months', status: 'completed' },
        { phase: 'Site Preparation', duration: '4 months', status: 'in-progress' },
        { phase: 'Infrastructure Development', duration: '6 months', status: 'upcoming' },
        { phase: 'Accommodation Construction', duration: '8 months', status: 'upcoming' },
        { phase: 'Soft Opening', duration: '2 months', status: 'upcoming' },
        { phase: 'Grand Opening', duration: '1 month', status: 'upcoming' }
      ],
      team: [
        { name: 'Sarah Mitchell', role: 'Project Director', experience: '15 years hospitality development' },
        { name: 'David Chen', role: 'Construction Manager', experience: '12 years sustainable construction' },
        { name: 'Emily Rodriguez', role: 'Operations Manager', experience: '10 years luxury resort operations' }
      ],
      risks: [
        'Weather delays during construction phase',
        'Permit approval timeline variations',
        'Market demand fluctuations',
        'Environmental compliance requirements'
      ],
      documents: [
        'Executive Summary',
        'Financial Projections',
        'Environmental Impact Study',
        'Market Analysis Report',
        'Legal Documentation'
      ]
    },
    {
      id: "alabama-gulf",
      numericId: 7,
      title: 'Alabama Gulf Shores',
      location: 'Gulf Coast Alabama',
      type: 'development',
      targetReturn: '21%',
      minInvestment: 140000,
      totalRaise: 2500000,
      currentRaised: 750000,
      timeline: '3 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Alabama%20Gulf%20Coast%20glamping%20investment%20property%20with%20elegant%20tiny%20homes%20near%20pristine%20white%20sand%20beaches%2C%20professional%20real%20estate%20photography%2C%20coastal%20setting%2C%20sophisticated%20beachside%20accommodations%2C%20southern%20coastal%20investment&width=800&height=500&seq=alabama-gulf-detail&orientation=landscape',
      highlights: ['Beach Access', 'Gulf Views', 'Water Sports', 'Private Beach'],
      description: 'Coastal Alabama glamping with pristine beaches and world-class fishing.',
      fullDescription: 'The Alabama Gulf Coast Sanctuary offers investors a rare opportunity to develop a luxury beachfront glamping destination on the pristine Alabama Gulf Coast. This 40-acre beachfront property features white sand beaches, clear Gulf waters, and protected coastal dunes. The development will include 12 luxury coastal accommodations, each with ocean views and beach access. Guests will enjoy private beach areas, water sports, fishing charters, and Gulf Coast cuisine. The location provides year-round appeal with mild winters and active summer beach seasons.',
      financials: {
        totalProjectCost: 3200000,
        landAcquisition: 800000,
        development: 1800000,
        infrastructure: 400000,
        contingency: 200000,
        projectedRevenue: {
          year1: 1400000,
          year2: 2000000,
          year3: 2600000
        },
        occupancyRate: '82%',
        averageDailyRate: 400
      },
      timelinePhases: [
        { phase: 'Coastal Permits & Studies', duration: '4 months', status: 'completed' },
        { phase: 'Beach Access Development', duration: '3 months', status: 'in-progress' },
        { phase: 'Coastal Infrastructure', duration: '5 months', status: 'upcoming' },
        { phase: 'Beachfront Unit Construction', duration: '8 months', status: 'upcoming' },
        { phase: 'Water Sports Facility', duration: '4 months', status: 'upcoming' },
        { phase: 'Beach Resort Opening', duration: '2 months', status: 'upcoming' }
      ],
      team: [
        { name: 'Gulf Alabama', role: 'Coastal Development Director', experience: '17 years Gulf Coast construction' },
        { name: 'Beach Coast', role: 'Marine Activities Manager', experience: '14 years water sports operations' },
        { name: 'Southern Waters', role: 'Beachfront Operations Director', experience: '16 years coastal hospitality' }
      ],
      risks: [
        'Hurricane seasonal risks',
        'Coastal erosion considerations',
        'Marine environmental regulations',
        'Beach access permit complexity'
      ],
      documents: [
        'Coastal Development Plan',
        'Marine Environmental Study',
        'Hurricane Preparedness Strategy',
        'Beach Access Rights',
        'Gulf Coast Tourism Analysis'
      ]
    },
    {
      id: "georgia-peach",
      numericId: 5,
      title: 'Georgia Peach Orchard',
      location: 'North Georgia',
      type: 'development',
      targetReturn: '17%',
      minInvestment: 115000,
      totalRaise: 1200000,
      currentRaised: 360000,
      timeline: '2 years',
      status: 'active',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Georgia%20peach%20orchard%20glamping%20investment%20property%20with%20charming%20tiny%20homes%20among%20blooming%20fruit%20trees%2C%20professional%20real%20estate%20photography%2C%20southern%20countryside%20setting%2C%20rustic%20elegance%20accommodations%2C%20agricultural%20tourism%20investment&width=800&height=500&seq=georgia-peach-detail&orientation=landscape',
      highlights: ['Orchard Setting', 'Farm-to-Table', 'Seasonal Beauty', 'Rustic Units'],
      description: 'Agritourism glamping in working peach orchards with farm-to-table experiences.',
      fullDescription: 'The Georgia Peach Orchard Retreat combines agricultural tourism with luxury glamping in a working peach orchard in North Georgia. This 60-acre property features mature peach trees, farm activities, and seasonal harvest experiences. The development will include 8 rustic-luxury accommodations designed to blend with the agricultural setting. Guests will enjoy farm-to-table dining, orchard tours, seasonal fruit picking, and traditional Southern hospitality. The retreat operates year-round with peak seasons during spring blossoms and summer harvest.',
      financials: {
        totalProjectCost: 1500000,
        landAcquisition: 300000,
        development: 900000,
        infrastructure: 200000,
        contingency: 100000,
        projectedRevenue: {
          year1: 500000,
          year2: 750000,
          year3: 950000
        },
        occupancyRate: '70%',
        averageDailyRate: 250
      },
      timelinePhases: [
        { phase: 'Orchard Assessment', duration: '1 month', status: 'completed' },
        { phase: 'Agricultural Permits', duration: '2 months', status: 'in-progress' },
        { phase: 'Farm Infrastructure', duration: '3 months', status: 'upcoming' },
        { phase: 'Rustic Unit Construction', duration: '6 months', status: 'upcoming' },
        { phase: 'Farm-to-Table Kitchen', duration: '3 months', status: 'upcoming' },
        { phase: 'Harvest Season Opening', duration: '1 month', status: 'upcoming' }
      ],
      team: [
        { name: 'Peach Georgia', role: 'Agricultural Tourism Director', experience: '18 years farm hospitality' },
        { name: 'Orchard Johnson', role: 'Farm Operations Manager', experience: '22 years peach farming' },
        { name: 'Southern Belle', role: 'Hospitality Coordinator', experience: '10 years rural tourism' }
      ],
      risks: [
        'Agricultural weather dependency',
        'Seasonal revenue concentration',
        'Crop yield variations',
        'Farm equipment maintenance'
      ],
      documents: [
        'Agricultural Tourism Plan',
        'Orchard Management Strategy',
        'Farm-to-Table Program',
        'Seasonal Activity Calendar',
        'Rural Development Permits'
      ]
    }
  ];

  // Find investment by string ID or numeric ID
  const investment = investments.find(inv => 
    inv.id === id || 
    inv.numericId.toString() === id ||
    inv.numericId === parseInt(id || '0')
  );

  if (!investment) {
    return (
      <div className="min-h-screen bg-white">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Investment Not Found</h1>
            <Link to="/investments" className="text-emerald-600 hover:text-emerald-700">
              Return to Investments
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const progressPercentage = (investment.currentRaised / investment.totalRaise) * 100;

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        {/* Hero Section */}
        <div className="relative h-96 overflow-hidden">
          <img 
            src={investment.image} 
            alt={investment.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <div className="max-w-3xl">
                <div className="flex items-center space-x-4 mb-4">
                  <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium capitalize">
                    {investment.type}
                  </span>
                  <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-medium capitalize">
                    {investment.status}
                  </span>
                </div>
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                  {investment.title}
                </h1>
                <div className="flex items-center text-white/90 mb-6">
                  <i className="ri-map-pin-line text-emerald-400 mr-2"></i>
                  <span className="text-lg">{investment.location}</span>
                </div>
                <p className="text-xl text-white/90 leading-relaxed">
                  {investment.description}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Investment Summary */}
        <div className="bg-gray-50 py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-gray-600 text-sm uppercase tracking-wide mb-2">Target Return</div>
                <div className="text-3xl font-bold text-emerald-600">{investment.targetReturn}</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-gray-600 text-sm uppercase tracking-wide mb-2">Min Investment</div>
                <div className="text-3xl font-bold text-gray-900">${investment.minInvestment.toLocaleString()}</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-gray-600 text-sm uppercase tracking-wide mb-2">Timeline</div>
                <div className="text-3xl font-bold text-gray-900">{investment.timeline}</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-gray-600 text-sm uppercase tracking-wide mb-2">Funding Progress</div>
                <div className="text-3xl font-bold text-gray-900">{Math.round(progressPercentage)}%</div>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                  <div 
                    className="bg-emerald-600 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="border-b border-gray-200 mb-8">
            <nav className="flex space-x-8">
              {[
                { id: 'overview', label: 'Overview' },
                { id: 'financials', label: 'Financials' },
                { id: 'timeline', label: 'Timeline' },
                { id: 'team', label: 'Team' },
                { id: 'documents', label: 'Documents' }
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                    activeTab === tab.id
                      ? 'border-emerald-500 text-emerald-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Project Overview</h2>
                <p className="text-gray-700 leading-relaxed mb-8">
                  {investment.fullDescription}
                </p>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">Key Highlights</h3>
                <div className="grid grid-cols-2 gap-4 mb-8">
                  {investment.highlights.map((highlight, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-line text-emerald-600 mr-3"></i>
                      <span className="text-gray-700">{highlight}</span>
                    </div>
                  ))}
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">Risk Factors</h3>
                <div className="space-y-3">
                  {investment.risks.map((risk, index) => (
                    <div key={index} className="flex items-start">
                      <i className="ri-alert-line text-amber-500 mr-3 mt-1"></i>
                      <span className="text-gray-700">{risk}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="bg-gray-50 p-6 rounded-xl">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Investment Summary</h3>
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Total Raise:</span>
                      <span className="font-semibold">${investment.totalRaise.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Raised to Date:</span>
                      <span className="font-semibold">${investment.currentRaised.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Remaining:</span>
                      <span className="font-semibold">${(investment.totalRaise - investment.currentRaised).toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Min Investment:</span>
                      <span className="font-semibold">${investment.minInvestment.toLocaleString()}</span>
                    </div>
                  </div>

                  <button className="w-full bg-emerald-600 text-white py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors mt-6 cursor-pointer whitespace-nowrap">
                    <Link to="/investment-packages" className="text-white">
                      Request Investment Package
                    </Link>
                  </button>

                  <div className="mt-4 text-center">
                    <Link to="/contact" className="text-emerald-600 hover:text-emerald-700 text-sm cursor-pointer">
                      Schedule a Call
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'financials' && (
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Financial Projections</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">Project Costs</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Total Project Cost:</span>
                        <span className="font-semibold">${investment.financials.totalProjectCost.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Land Acquisition:</span>
                        <span className="font-semibold">${investment.financials.landAcquisition.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Development:</span>
                        <span className="font-semibold">${investment.financials.development.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Infrastructure:</span>
                        <span className="font-semibold">${investment.financials.infrastructure.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Contingency:</span>
                        <span className="font-semibold">${investment.financials.contingency.toLocaleString()}</span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">Revenue Projections</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Year 1:</span>
                        <span className="font-semibold">${investment.financials.projectedRevenue.year1.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Year 2:</span>
                        <span className="font-semibold">${investment.financials.projectedRevenue.year2.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Year 3:</span>
                        <span className="font-semibold">${investment.financials.projectedRevenue.year3.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Occupancy Rate:</span>
                        <span className="font-semibold">{investment.financials.occupancyRate}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Average Daily Rate:</span>
                        <span className="font-semibold">${investment.financials.averageDailyRate}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'timeline' && (
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Development Timeline</h2>
              <div className="space-y-6">
                {investment.timelinePhases.map((phase, index) => (
                  <div key={index} className="flex items-start">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1 ${
                      phase.status === 'completed' ? 'bg-emerald-600' :
                      phase.status === 'in-progress' ? 'bg-blue-600' :
                      'bg-gray-300'
                    }`}>
                      {phase.status === 'completed' ? (
                        <i className="ri-check-line text-white text-sm"></i>
                      ) : phase.status === 'in-progress' ? (
                        <i className="ri-time-line text-white text-sm"></i>
                      ) : (
                        <i className="ri-more-line text-gray-600 text-sm"></i>
                      )}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900">{phase.phase}</h3>
                      <p className="text-gray-600">Duration: {phase.duration}</p>
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium mt-2 capitalize ${
                        phase.status === 'completed' ? 'bg-emerald-100 text-emerald-800' :
                        phase.status === 'in-progress' ? 'bg-blue-100 text-blue-800' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {phase.status.replace('-', ' ')}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'team' && (
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Project Team</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {investment.team.map((member, index) => (
                  <div key={index} className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-user-line text-white text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 text-center mb-2">{member.name}</h3>
                    <p className="text-emerald-600 font-medium text-center mb-2">{member.role}</p>
                    <p className="text-gray-600 text-sm text-center">{member.experience}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'documents' && (
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Investment Documents</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {investment.documents.map((document, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:border-emerald-300 transition-colors">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <i className="ri-file-text-line text-emerald-600 text-xl mr-3"></i>
                        <span className="font-medium text-gray-900">{document}</span>
                      </div>
                      <button className="text-emerald-600 hover:text-emerald-700 cursor-pointer whitespace-nowrap">
                        <i className="ri-download-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 p-6 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-start">
                  <i className="ri-information-line text-amber-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h3 className="font-semibold text-amber-800 mb-2">Document Access</h3>
                    <p className="text-amber-700">
                      Full investment documentation is available to qualified investors. Please contact our investment team to request access to detailed financial models, legal documents, and due diligence materials.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="bg-emerald-600 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">Ready to Invest?</h2>
            <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
              Join our network of successful investors and be part of the growing glamping industry.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/investment-packages"
                className="bg-white text-emerald-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Request Investment Package
              </Link>
              <a
                href="tel:256-268-7146"
                className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap"
              >
                Schedule Consultation
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
